// utils/delay.ts
export const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => {
      console.log(`Delaying for ${ms} milliseconds`);
      setTimeout(resolve, ms);
    });
  };
  